import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { Country, ListResponse } from '@/types';
import { Pagination } from '@/components';
import theme from '@/theme';
import { EditFlat, TrashFlat } from '@/assets/icons';

import { DeleteCountry, UpdateCountry } from '../components';

export interface CountryListProps {
  list?: ListResponse<Country>;
  page: number;
  onChangePage(page: number): void;
}

const CountriesTable: React.FC<CountryListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentCountry, setCurrentCountry] = useState<Country | null>(null);

  function openUpdateModal(country: Country) {
    setCurrentCountry(country);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(country: Country) {
    setCurrentCountry(country);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Наименование</TableCell>
                <TableCell>Код для ГКБ</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((country) => {
                const { code, name, id } = country;

                return (
                  <TableRow key={id}>
                    <TableCell>{name}</TableCell>
                    <TableCell>{code}</TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(country)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(country)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateCountry country={currentCountry!} open={updateModalOpened} onClose={() => setOpenedUpdateModal(false)} />
      <DeleteCountry country={currentCountry!} open={deleteModalOpened} onClose={() => setOpenedDeleteModal(false)} />
    </>
  );
};

export default CountriesTable;
